import { Component, EventEmitter, Input, OnInit, Output, Renderer2, TemplateRef } from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth.service';
import { CurrentMenuStateService } from 'src/app/services/current-menu-state.service';
import { UnlServiceService } from 'src/app/services/unl-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-menu-lg',
  templateUrl: './side-menu-lg.component.html',
  styleUrls: ['./side-menu-lg.component.scss']
})
export class SideMenuLgComponent implements OnInit {

  @Input() menus = [];
  @Input() termId = '';
  @Output() menuEvent = new EventEmitter<string>();
  @Output() menuColapsed = new EventEmitter<any>();
  envType  = environment.environmentType;
  modalRef: BsModalRef;

  isCollapsed = false;
  selectedItem: any;
  windowWidth: number;
  isAuthenticated: boolean = false;
  ctype: string;

  constructor(private router: Router,private route: ActivatedRoute,private unlServiceService: UnlServiceService,
    private modalService: BsModalService,
    private currentMenuStateService: CurrentMenuStateService,
    private renderer: Renderer2,private readonly authService: AuthService) { 
    this.updateWindowWidth();
    this.renderer.listen('window', 'resize', (event) => this.updateWindowWidth());
    this.router.events.subscribe((event) => {    
      if (event instanceof ActivationEnd && event.snapshot.params.ctype) {
        var ctype = event.snapshot.params.ctype;
        if (ctype === undefined) {
          this.ctype = "all"
        }
        this.ctype = ctype;
        var cIndex = this.unlServiceService.getIndexBycType(ctype);
        let item = this.unlServiceService.menus[cIndex];
        this.selectedItem = item;
      }

    });
  }

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.menuColapsed.emit(this.isCollapsed);
  }

  menuclick(menu: any) : void {
    console.log(menu);
    if(menu.title.toLowerCase() ===  'login') {
      this.router.navigate(['/login']);
    }
    this.selectedItem = menu;
    this.router.navigate(['/', menu.link, this.termId]);
    this.menuEvent.emit(menu);
  }

  updateWindowWidth() {
    this.windowWidth = window.innerWidth;
    this.isCollapsed = this.windowWidth <= 1280;
    this.menuColapsed.emit(this.isCollapsed);
  }

  hideMenu(item: any) {
   return item.title.toLowerCase() === 'login' && this.isAuthenticated;
  }

  toggleMenu(s: string) {
    this.ctype = s;
    this.currentMenuStateService.updateCurrentState({ menu: s })
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm modalsizecls' });
  }
  
  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

}
